<template>
    <div>
        <div
            v-if="isLoading"
            class="spinner-holder"
        >
            <ui-spinner />
        </div>

        <p class="mb-3 font-weight-bold">
            {{ $t(`dashboard.${keyMain}`) }}

            <span
                v-if="tooltip"
                v-tippy="{ content: tooltip }"
                class="tooltip"
            >
                <ui-icon icon="info" />
            </span>
        </p>
        <ul class="d-flex flex-wrap align-items-center list gap-2 mb-3">
            <li
                v-for="(item, index) in keyItems"
                :key="item"
                class="d-flex align-items-center gap-2 text-smaller"
            >
                <span
                    :style="{ backgroundColor: colors[index] }"
                    class="legend"
                />
                <span>
                    {{ $t(`dashboard.${item}`) }}
                </span>
            </li>
        </ul>

        <div class="mb-n3">
            <div
                v-for="item in Object.keys(data)"
                :key="item"
                class="d-flex align-items-center gap-2 mb-3"
            >
                <span class="w-30">
                    {{ $t(`dashboard.${item}`) }}
                </span>

                <ul class="list flex-grow-1">
                    <li
                        v-for="(value, key, index) in data[item]"
                        :key="value"
                        :style="{
                            backgroundColor: colors[index],
                            width: `${value / highestValueInData * 100 }%`
                        }"
                        class="bar"
                    >
                        <span>
                            {{ value }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import UiSpinner from '../ui/spinner.vue';
import UiIcon from '../ui/icon.vue';

export default {
    name: 'WidgetBarChartHorizontal',
    components: {
        UiSpinner,
        UiIcon,
    },
    props: {
        colors: {
            type: Array,
            required: true,
        },
        keyItems: {
            type: Array,
            required: true,
        },
        keyMain: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            required: false,
        },
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            data: [],
            isLoading: true,
        };
    },
    mounted() {
        this.fetch();
    },
    computed: {
        ...mapState('dashboard', [
            'query',
        ]),

        highestValueInData() {
            return Math.max(...Object.values(this.data)
                .map(item => Math.max(...Object.values(item))));
        },
    },
    methods: {
        async fetch() {
            this.isLoading = true;

            const { data: { data } } = await axios.get(this.url, { params: this.query });

            this.data = data;
            this.isLoading = false;
        },
    },
    watch: {
        query() {
            this.fetch();
        },
    },
};
</script>

<style lang="scss" scoped>
    .legend {
        display: block;
        width: 12px;
        height: 12px;
        border-radius: 3px;
    }

    .bar {
        position: relative;
        display: block;
        width: 0;
        height: 24px;
        padding: 0;
        margin-bottom: 4px;
        font-size: 14px;
        font-weight: bold;
        line-height: 26px;
        white-space: nowrap;
        transition: 0.3s;

        &:last-child {
            margin-bottom: 0;
        }

        span {
            position: absolute;
            left: 16px;
        }
    }
</style>
